import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Alert, Grid, Skeleton } from '@mui/material';

const TextDefault = forwardRef((props, ref) => {
  const { isLoading, text, sx } = props;

  if (isLoading) {
    return (
      <Grid id="text-default" ref={ref} item xs={12} sx={sx}>
        <Skeleton id="skeleton-template-list-head" variant="rounded" height={48} width="100%" />
      </Grid>
    );
  }

  if (!text?.length) {
    return;
  }

  return (
    <Grid id="text-default" ref={ref} item xs={12} sx={sx}>
      <Alert component="pre" severity="info" sx={{ mx: { xs: 1, sm: 0 } }}>
        {text}
      </Alert>
    </Grid>
  );
});

TextDefault.propTypes = {
  isLoading: PropTypes.bool,
  text: PropTypes.string,
  sx: PropTypes.object
};

export default TextDefault;
